import { useDialog } from 'muibox';
import { useContext } from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { SettingsContext } from '../store/SettingsContext';
import { UserContext } from '../store/UserContext';
import useAxios from './useAxios';
import { OnlyFansAllCounters } from './useMetricsDailyStats';

const useMetricsDailyStatsCountersAllWeek = () => {
    const userContext = useContext(UserContext);
    const settingsContext = useContext(SettingsContext);
    const dialog = useDialog();
    const params = useParams();
    const axios = useAxios();

    // Fetch online users count vs. total sales report
    const fetchData = async (): Promise<{ _id: Date; counters?: OnlyFansAllCounters }[]> => {
        const query: string = `${settingsContext.routes.metrics.base}${params.userId}/countersAll/week`;

        const data = await axios
            .get(query)
            .then(async response => response.data)
            .catch(error => {
                console.error('Error fetching metrics daily stats counters all week:', error);

                return [];
            });

        return data;
    };

    return useQuery(
        ['metricsDailyStatsCountersAllWeek', params.userId],
        () => {
            return fetchData();
        },
        {
            refetchOnWindowFocus: false,
            // Stale time 1 hour
            staleTime: 60 * 60 * 1000,
            enabled: userContext.jwtToken && settingsContext.apiKey && params.userId ? true : false,
        },
    );
};

export default useMetricsDailyStatsCountersAllWeek;
